export default "__VITE_ASSET__BgriXU5w__"